import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import type { authorBioAuthor$key } from "~/queries/__generated__/authorBioAuthor.graphql";

import { StyledDiv } from "./styles";

export type Props = {
  reference: authorBioAuthor$key;
};

export const AuthorBio: FunctionComponent<Props> = ({ reference: reference_ }) => {
  const author = useFragment(
    graphql`
      fragment authorBioAuthor on Author {
        bio
      }
    `,
    reference_,
  );
  return <StyledDiv>{author.bio}</StyledDiv>;
};

AuthorBio.displayName = "AuthorBio";
